import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var PooBolt = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 448 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M236.9.2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1 0 44.3-35.8 80.1-80 80.1-1.4 0-2.8.2-4 .5H128c-35.3 0-64 28.7-64 64 0 12.4 3.5 24 9.7 33.8C31.6 234.3 0 271.5 0 316c0 49.1 38.5 89.2 86.9 91.9-1.8-2.9-3.4-6.1-4.5-9.4-6-17.5-.5-36.9 13.6-48.5l142.2-116.4c15.6-12.8 37.9-12.7 53.5.1s20.3 35.1 11.3 53.4l-26 53.2h16.3c18.1 0 34.3 11.7 40.3 29.2 4.5 13.1 2.6 27.3-4.6 38.4h27c50.8 0 92-41.2 92-92 0-44.5-31.6-81.7-73.7-90.2 6.1-9.8 9.7-21.4 9.7-33.8 0-35.3-28.7-64-64-64h-5.7c3.7-10.2 5.7-21.1 5.7-32.6 0-48.7-36.1-88.9-83.1-95.2zm34.2 259.2c-6-4.6-14.3-4.4-20.1.4l-133.4 112c-5.2 4.3-7 11.4-4.7 17.7s8.3 10.5 15 10.5h54.7l-42.5 89.1c-3.2 6.8-1.3 14.9 4.7 19.5s14.3 4.4 20.1-.4l133.4-112c5.1-4.3 7-11.4 4.7-17.7s-8.3-10.5-15-10.5h-54.7l42.5-89.1c3.2-6.8 1.3-14.9-4.7-19.5z"
  }));
});
PooBolt.displayName = 'PooBolt';
export var PooBoltDimensions = {
  height: 512,
  width: 448
};